import { render, staticRenderFns } from "./drawOpenPres.vue?vue&type=template&id=60d3e012&scoped=true&"
import script from "./drawOpenPres.vue?vue&type=script&lang=js&"
export * from "./drawOpenPres.vue?vue&type=script&lang=js&"
import style0 from "./drawOpenPres.vue?vue&type=style&index=0&id=60d3e012&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d3e012",
  null
  
)

export default component.exports